export default __webpack_public_path__ + "static/yes-bank-e01b8d73ee19fb07b4c08c1264aaf237.png";